var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.194,
    height: 19.927,
    viewBox: "0 0 25.194 19.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(1.393 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M5.241,6H23.168a2.247,2.247,0,0,1,2.241,2.241V21.686a2.247,2.247,0,0,1-2.241,2.241H5.241A2.247,2.247,0,0,1,3,21.686V8.241A2.247,2.247,0,0,1,5.241,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "#bcbbbb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111",
    "data-name": "Trac\\xE9 111",
    d: "M25.409,9,14.2,16.843,3,9",
    transform: "translate(-3 -6.759)",
    fill: "none",
    stroke: "#bcbbbb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9ecf8b67847d9f3e020501598c5dbcbf.svg";
export { ForwardRef as ReactComponent };